export default {
  // push event from client
  on(event, resolve) {
    this.events.push({ event, resolve });
  }
}

